import React from 'react'

export const InterestedJobCandidates = () => {
  return (
    <div>InterestedJobCandidates</div>
  )
}
